import React from 'react';

import { CountdownModal } from 'src/components/modals/countdown-modal';
import { EndSessionModalContainer } from './end-session-modal.styles';

export const EndSessionModal = ({
  startNewSession,
  isOpen,
  handleCloseModal,
}: {
  startNewSession: () => void;
  isOpen: boolean;
  handleCloseModal: () => void;
}): JSX.Element => (
  <EndSessionModalContainer
    isOpen={isOpen}
    onRequestClose={handleCloseModal}
    width='820px'
    alignItems='center'
    padding='40px'
    borderRadius='20px'
    ariaHideApp={false}
    data-testid='kiosk-pro-end-session-modal'
  >
    <CountdownModal
      startNewSession={startNewSession}
      closeAndContinue={handleCloseModal}
      timeLeftInSeconds={10}
      title='Are you sure you want to end the session?'
      subtitle='You will lose any items currently in your cart and have to start over.'
      primaryButtonText='Cancel & start over'
      secondaryButtonText='Keep Shopping'
    />
  </EndSessionModalContainer>
);
